var map = {
	"./decidim/avatar-multiuser.png": 17053,
	"./decidim/brands/facebook.svg": 44425,
	"./decidim/brands/google.svg": 21504,
	"./decidim/brands/twitter-x.svg": 96885,
	"./decidim/cc-badge.png": 53291,
	"./decidim/decidim-logo.svg": 2783,
	"./decidim/default-avatar.svg": 64275,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 82809,
	"./decidim/icons.svg": 40066,
	"./decidim/pattern.png": 80449,
	"./decidim/placeholder-card-g.svg": 80558,
	"./decidim/placeholder-card-l.svg": 72709,
	"./decidim/placeholder.jpg": 94484,
	"./decidim/remixicon.symbol.svg": 4374,
	"./decidim/vendor/social-share-button/douban.svg": 46425,
	"./decidim/vendor/social-share-button/email.svg": 56346,
	"./decidim/vendor/social-share-button/facebook.svg": 50962,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 35166,
	"./decidim/vendor/social-share-button/hacker_news.svg": 92058,
	"./decidim/vendor/social-share-button/linkedin.svg": 30984,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 37057,
	"./decidim/vendor/social-share-button/pinterest.svg": 38884,
	"./decidim/vendor/social-share-button/reddit.svg": 87486,
	"./decidim/vendor/social-share-button/telegram.svg": 26335,
	"./decidim/vendor/social-share-button/tumblr.svg": 46812,
	"./decidim/vendor/social-share-button/twitter.svg": 55855,
	"./decidim/vendor/social-share-button/vkontakte.svg": 75053,
	"./decidim/vendor/social-share-button/wechat.svg": 29168,
	"./decidim/vendor/social-share-button/whatsapp.svg": 55920,
	"./decidim/vendor/social-share-button/x.svg": 7898,
	"./decidim/vendor/social-share-button/xing.svg": 23726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8576;